<template>
  <router-link to="cover" append>
    <div
      :class="{
        'cover-image': true,
        active: active,
        default: !coverImage.src,
      }"
    >
      <transition name="fade">
        <img
          :key="coverImage.src || 'default'"
          :src="coverImage.src || '/themes/sloan/img/design-spec-placeholder.png'"
          :alt="coverImage.alt"
        />
      </transition>
      <SloIcon name="Images" />
      <div class="overlay">
        <p>{{ 'Cover Image' | t }}</p>
      </div>
    </div>
  </router-link>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import t from '../../main/i18n';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    SloIcon
  },
  filters: {
    t
  },
  computed: {
    ...mapGetters('designspec', {getProject: 'project'}),
    ...mapState('designspec', {coverImages: state => state.coverImages}),
    project() {
      return this.getProject(Number(this.$route.params.id));
    },
    coverImage() {
      return (
        this.coverImages.find(({value}) => value === this.project.cover_image_id) ||
        {}
      );
    },
    active() {
      return this.$route.path.indexOf('/cover') > -1;
    }
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';

.cover-image {
  position: relative;
  overflow: hidden;
  padding-top: calc((3 / 5) * 100%);
  background: $color-gray-200;
  max-width: 100%;

  .slo-icon {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 52px;
    height: 52px;
    background: rgba($color-gray-900, 0.5);
    z-index: 1;
    color: white;
    font-size: 24px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 200ms cubic-bezier(0.23, 1, 0.32, 1);
    border-radius: 999px;
  }

  .overlay {
    position: absolute;
    display: flex;
    align-items: center;
    bottom: 0;
    left: 0;
    right: 0;
    height: 52px;
    background: linear-gradient(to bottom, rgba($color-gray-900, 0), rgba($color-gray-900, 0.67));
    padding: 16px 12px;
    opacity: 0;
    transition: opacity 350ms cubic-bezier(0.23, 1, 0.32, 1);

    p {
      @include text('lg', 'strong');
      color: white;
    }
  }

  &.active,
  &:hover {
    .overlay,
    .slo-icon {
      opacity: 1;
    }

    > img {
      transform: scale(1.025);
    }
  }

  &.active {
    > img {
      transform: scale(1.1);
    }
  }

  &.default {
    > img {
      width: 67%;
      height: 67%;
      margin: auto;
      bottom: 0;
      right: 0;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 250ms linear;
  }

  .fade-leave-active {
    transition-duration: 200ms;
    transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  }

  .fade-enter-active {
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}

.cover-image > img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 400ms cubic-bezier(0.075, 0.82, 0.165, 1);
}
</style>
